import React from "react";
import SlickSlider from "react-slick";
import styled from "styled-components";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

const SliderComponent = () => (
	<Slider {...settings}>
		<div className="carousel-item active">
			<h2>
				Wouldn't you like to
				<br />
				<span>
					be able to consult your
					<br /> patient's information
				</span>
				<br />
				where you need to?
			</h2>
			<button type="button" className="btn sign-btn mt-5">
				Our features
			</button>
		</div>
		<div className="carousel-item">
			<h2>
				Wouldn't you like to
				<br />
				<span>
					be able to consult your <br /> patient's information
				</span>
				<br />
				where you need to?
			</h2>
			<button type="button" className="btn sign-btn mt-5">
				Our features
			</button>
		</div>
		<div className="carousel-item">
			<h2>
				Wouldn't you like to
				<br />
				<span>
					be able to consult your
					<br /> patient's information
				</span>
				<br />
				where you need to?
			</h2>
			<button type="button" className="btn sign-btn mt-5">
				Our features
			</button>
		</div>
	</Slider>
);
export default SliderComponent;

const Slider = styled(SlickSlider)`
  .slick-arrow {
    display: none !important;
  }
  .slick-dots {
    li {
      button {
        &::before {
          content: "-";
          font-size: 74px;
          color: #fff !important;
        }
      }
      &.slick-active {
        button {
          &::before {
            color: #e78e4b !important;
          }
        }
      }
    }
  }
`;
